import '@vfde-brix/image-header/dist/styles.css';
import '@vfde-brix/highlight-badge/dist/styles.css';
import { createImageHeaderComponent } from '@vfde-brix/image-header';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-image-header', createImageHeaderComponent, NO_PATTERN_BUSINESS_LOGIC, element => element);
